import { updateResourceCustomFields } from "../../actions/resourceActions"
import { toggleUnsaved }              from "../../actions/exitIntentActions"

const submit = async (values, dispatch) => {
  await dispatch(updateResourceCustomFields(values.resourceId, { customFields: values.customFields }))
  dispatch(toggleUnsaved(false))
}

export default submit